import { configureStore } from '@reduxjs/toolkit';
//import logger from 'redux-logger';
import ApiServices from 'api/services';
import rootReducer from './rootReducer';
import notificationMiddleware from 'redux/middleware/notificationMiddleware';
// import authMiddleware from 'redux/middleware/authMiddleware';

const ENVIRONMENT =
  process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || false;

const IS_PRODUCTION = ENVIRONMENT === 'production';
const DISABLE_NOTIFICATIONS = !!process.env.DISABLE_NOTIFICATIONS;

// extra arguments for thunk
const extraThunkArguments = {
  API: ApiServices, // all api services
};
const middleware = (getDefaultMiddleware) => {
  const defaultMiddleware = getDefaultMiddleware({
    thunk: {
      extraArgument: extraThunkArguments,
    },
    immutableCheck: !IS_PRODUCTION,
    serializableCheck: !IS_PRODUCTION,
  });

  let customMiddleware = defaultMiddleware;
  //if (!IS_PRODUCTION) customMiddleware = customMiddleware.concat(logger);
  // customMiddleware = customMiddleware.concat(authMiddleware);
  if (!DISABLE_NOTIFICATIONS)
    customMiddleware = customMiddleware.concat(notificationMiddleware);
  return customMiddleware;
};

const store = configureStore({
  reducer: rootReducer,
  middleware,
});

extraThunkArguments.store = store; // adding store as extra thunk arg

export default store;
